import classNames from "classnames";

// Hooks
import useTranslate from "hooks/useTranslate";

// Constants
import { PRIZE_LIST } from "constants/wheel";

import "./styles.sass";

type DiskGirlProps = {
  angle: number;
};

const DiskGirl = (props: DiskGirlProps) => {
  const { angle } = props;
  const t = useTranslate();

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const spin = {
    transform: `rotate(${angle}deg)`,
  };

  const componentClass = classNames("DiskGirl", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });

  const nameClass = classNames("DiskGirl__name", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <div className="DiskGirl__wrapper">
      <div className={componentClass} style={spin}>
        <div className={nameClass} />
        {VITE_APP_PROJECT_NAME === "banger" ? null : (
          <div className="DiskGirl-text">
            {PRIZE_LIST.map((item) => (
              <div
                key={item.id}
                style={{ transform: `rotate(${item.angle}deg)` }}
                className="DiskGirl-text__value"
              >
                {t(item.title)}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DiskGirl;
